import React from "react"
import { EDIT_TYPE } from "../../../../../../../../types"
import { Buttons } from "../../components/buttons"
import BaseDraftEditor from "../../abstract/base-draft-editor"
import {
  CustomStyleEditor,
  EditorWrapper,
} from "../../components/custom-style-editor"
import { ToolBarWithoutSize } from "../../components/tool-bar"
import styled from "styled-components"
import { container } from "../container"
import { ChatFontStyle } from "../../../../../../../../../../components/templates/chat/components/styles/chat-font-style"

class Component extends BaseDraftEditor {
  public render() {
    if (this.props.content._editMetaData.type === EDIT_TYPE.MENU) {
      return (
        <StyledEditorWrapper onClick={this.editMode}>
          <CustomStyleEditor
            editorState={this.state.editorState}
            onChange={this.onChange}
          />
        </StyledEditorWrapper>
      )
    }

    return (
      <>
        <ToolBarWithoutSize
          onChange={this.onChange}
          editorState={this.state.editorState}
        />
        <StyledEditorWrapper>
          <CustomStyleEditor
            editorState={this.state.editorState}
            onChange={this.onChange}
          />
        </StyledEditorWrapper>
        <Buttons save={this.save} cancel={this.cancel} />
      </>
    )
  }
}

export const IntroductionEditor = container(Component)

const StyledEditorWrapper = styled(EditorWrapper)`
  ${ChatFontStyle.INTRODUCTION};
`
